<template>
    <div>
        <NavbarStyleTwo />
        <!-- <PageTitle
            pageTitle="Kontakt"
            pageDesc="Schreiben Sie uns bei Fragen"
        /> -->
        <Contact />
        <OurLovingClients />
        <Footer :showDivider="true" />
    </div>
</template>

<script>
import { useHead } from '@vueuse/head';
import NavbarStyleTwo from '../Layouts/NavbarStyleTwo';
// import PageTitle from '../Common/PageTitle';
import Contact from '../Contact/Contact';
import OurLovingClients from '../Common/OurLovingClients';
import Footer from '../Layouts/Footer';

export default {
    setup() {
        useHead({
            title: 'Kontakt - Benovium | Kostenlose Erstberatung',
            meta: [
                { name: 'description', content: 'Kontaktieren Sie Benovium für ein kostenloses Erstgespräch. Telefon: +43 660 578 2160 oder schreiben Sie uns eine Nachricht. Webentwicklung & SEO aus Wien.' },
                { property: 'og:title', content: 'Kontakt - Benovium' },
                { property: 'og:description', content: 'Kostenloses Erstgespräch für Webentwicklung & SEO.' },
                { property: 'og:url', content: 'https://benovium.com/contact' },
            ],
            link: [
                { rel: 'canonical', href: 'https://benovium.com/contact' }
            ]
        });
    },
    components: {
        NavbarStyleTwo,
        // PageTitle,
        Contact,
        OurLovingClients,
        Footer,
    }
};
</script>